import {
  Grid,
  Box,
  ListItemButton,
  ListItemIcon,
  Collapse,
  Divider,
  Card,
  Typography,
  AppBar,
  Backdrop,
  Stack,
  CircularProgress,
  Tooltip,
  Snackbar,
  Alert,
} from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import TuneIcon from "@mui/icons-material/Tune";
import SettingsIcon from "@mui/icons-material/Settings";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import React, { useState, useLayoutEffect, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import Firstrunexp from "./Firstrunexp";
import CloudDownloadRoundedIcon from "@mui/icons-material/CloudDownloadRounded";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TableViewRoundedIcon from "@mui/icons-material/TableViewRounded";
import AutoStoriesRoundedIcon from "@mui/icons-material/AutoStoriesRounded";
import { readLockedID, GetLockdetails } from "../../../utilities/Wordutil";
import LockTwoToneIcon from "@mui/icons-material/LockTwoTone";
import axiosBaseURL from "../../../utilities/httpCommon";
import OfficeAddinMessageBar from "./OfficeAddinMessageBar";

/* global Word localStorage console sessionStorage*/

const HomePage = (props: any) => {
  const history = useHistory();
  const [optionopen, setoptionopen] = useState(false);
  const [isprogress, setprogress] = useState(false);
  const [skipGet, setSkipGet] = useState("1");
  const [usernameinfo, setusernameinfo] = useState("");
  const [locked, setlocked] = useState(false);
  const [lockedname, setlockedname] = useState("");
  const [IsTemplate, setIsTemplate] = useState(false);
  const [errMsgd, seterrMsgd] = useState("");
  const [errMsgdTable, seterrMsgdTable] = useState("");
  const [islocked, setislocked] = useState(false);
  const [popupopen, setpopupopen] = React.useState(false);

  const handlepopupClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    seterrMsgdTable("");
    setpopupopen(false);
  };

  const handleClick = () => {
    setoptionopen(!optionopen);
  };

  const errorDismissed = () => {
    seterrMsgd("");
  };

  const CheckforTableinCC = async () => {
    setpopupopen(false);
    await Word.run(async (context) => {
      let getseltable = context.document.getSelection().tables.getFirstOrNullObject();
      let getseltable1 = context.document.getSelection().parentTableOrNullObject;
      await context.sync();
      if (getseltable.isNullObject && getseltable1.isNullObject) {
        seterrMsgdTable("Please select table to continue");
        setpopupopen(true);
        return;
      } else {
        history.push("/Marktable");
        return;
      }
    });
  };

  async function GetAIAssistantInfo() {
    console.log("called-validate");
    setprogress(true);
    const res = await axiosBaseURL
      .get("/sfserver/auth/validate", {
        withCredentials: true,
      })
      .catch((error: any) => {
        setprogress(false);
        console.log(error);
        // if (error.response) {
        //   console.log(error.response);
        //   seterrMsgd(error.response.data);
        // } else if (error.request) {
        //   seterrMsgd(error.request);
        // } else {
        //   seterrMsgd(error.message);
        // }
        return null;
      });
    setprogress(false);
    console.log(res);
    if (res.data != null && res.data.aienable != null) {
      setislocked(res.data.aienable);
    }
    return res;
  }

  function GetSkipInfo() {
    if (localStorage.getItem("skipfirstrun") != null) {
      setSkipGet(localStorage.getItem("skipfirstrun"));
    } else if (sessionStorage.getItem("skipfirstrun") != null) {
      setSkipGet(sessionStorage.getItem("skipfirstrun"));
    } else setSkipGet("0");
    console.log("Skip info...");
    console.log(skipGet);
    setusernameinfo(localStorage.getItem("sfuserinfo"));
  }

  // const QueryData = async (soqlquery: string, childrelation: boolean) => {
  //   try {
  //     setprogress(true);
  //     const res = await axiosBaseURL
  //       .get("/query?q=" + soqlquery, {
  //         withCredentials: true,
  //       })
  //       .catch((error) => {
  //         setprogress(false);
  //         if (error.response) {
  //           seterrMsgd(error.response.data);
  //         } else if (error.request) {
  //           seterrMsgd(error.request);
  //         } else {
  //           seterrMsgd(error.message);
  //         }
  //       });
  //     setprogress(false);
  //     console.log("res.data");
  //     console.log(res.data);
  //     if (res.data != null) {
  //       if (!childrelation) return res.data.records;
  //       else if (childrelation) return res.data;
  //     } else return null;
  //   } catch (err) {
  //     setprogress(false);
  //   }
  // };

  const CheckDocumentLock = async () => {
    setlocked(false);
    setprogress(true);
    let doctempId = await readLockedID();
    let loginUsrid = localStorage.getItem("sfuserid");
    console.log("loginUsrid");
    console.log(doctempId);
    if (doctempId != null && doctempId != "" && loginUsrid != null) {
      setIsTemplate(true);
      let doclock = await GetLockdetails(doctempId);
      if (doclock != null && doclock.id != "NA") {
        if (doclock.id != loginUsrid) {
          setlockedname("Locked by " + doclock.name);
          setlocked(true);
        }
      }
    } else {
      setIsTemplate(false);
    }
    setprogress(false);
  };

  useEffect(() => {
    seterrMsgdTable("");
    //Check for template ID
    CheckDocumentLock();
    //Ends here
    GetAIAssistantInfo();
  }, []);

  useLayoutEffect(() => {
    GetSkipInfo();
    console.log(props.Enableaih);
  });

  return (
    <Box sx={{ p: 2, marginTop: 0, alignContent: "center" }}>
      {errMsgd.length > 0 ? <OfficeAddinMessageBar onDismiss={errorDismissed} message={errMsgd + " "} /> : null}
      {skipGet === "0" ? (
        <Firstrunexp setSkipGet={setSkipGet} />
      ) : (
        <Grid container spacing={1}>
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isprogress}>
            <CircularProgress color="inherit" />
          </Backdrop>
          {errMsgd.length > 0 ? <OfficeAddinMessageBar onDismiss={errorDismissed} message={errMsgd + " "} /> : null}
          {IsTemplate && locked && (
            <Grid
              container
              direction="row"
              sx={{
                justifyContent: "right",
                alignItems: "flex-end",
              }}
            >
              <Grid item>
                <Stack direction="row">
                  <Typography variant="subtitle1">Status:</Typography>
                  <Tooltip title={lockedname}>
                    <LockTwoToneIcon sx={{ marginLeft: 1, color: "#1C39BB" }} />
                  </Tooltip>
                </Stack>
              </Grid>
              {/* <Grid item>
                <IconButton aria-label="delete" onClick={CheckDocumentLock} sx={{ padding: 0.25, marginLeft: 2 }}>
                  <RefreshIcon />
                </IconButton>
              </Grid> */}
            </Grid>
          )}
          {/* {IsTemplate && !locked && (
            <>
              <Grid
                container
                direction="row"
                sx={{
                  justifyContent: "right",
                  alignItems: "flex-end",
                }}
              >
                <Grid item>
                  <Stack direction="row">
                    <Typography variant="subtitle1">Status:</Typography>
                    <LockOpenTwoToneIcon sx={{ marginLeft: 1, color: "#1C39BB" }} />
                  </Stack>
                </Grid>                
              </Grid>
            </>
          )} */}
          <Grid xs={12} item>
            <Card variant="elevation">
              <List sx={{ width: "100%", bgcolor: "background.paper" }}>
                <ListItemButton onClick={() => history.push("/Newtemplate")}>
                  <ListItemIcon>
                    <AddCircleRoundedIcon sx={{ color: "#1C39BB" }} />
                  </ListItemIcon>
                  <ListItemText primary="New template" />
                  <ChevronRightIcon />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton onClick={() => history.push("/Insertfield")}>
                  <ListItemIcon>
                    <TextFieldsIcon sx={{ color: "#1C39BB" }} />
                  </ListItemIcon>
                  <ListItemText primary="Insert field" />
                  <ChevronRightIcon />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton onClick={() => history.push("/Inserttable")}>
                  <ListItemIcon>
                    <TableViewRoundedIcon sx={{ color: "#1C39BB" }} />
                  </ListItemIcon>
                  <ListItemText primary="Insert table" />
                  <ChevronRightIcon />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton onClick={handleClick}>
                  <ListItemIcon>
                    <TuneIcon sx={{ color: "#1C39BB" }} />
                  </ListItemIcon>
                  <ListItemText primary="Mark conditions" />
                  {optionopen ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={optionopen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding sx={{ marginLeft: 7 }}>
                    <ListItem disablePadding key="Mark condition1">
                      <ListItemButton onClick={() => history.push("/Markcondition")}>
                        <ListItemText primary="Mark field condition" />
                        <ChevronRightIcon />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding key="Mark condition2">
                      <ListItemButton onClick={() => history.push("/Markclause")}>
                        <ListItemText primary="Mark clause condition" />
                        <ChevronRightIcon />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding key="Mark condition3">
                      <ListItemButton onClick={CheckforTableinCC}>
                        <ListItemText primary="Mark table condition" />
                        <ChevronRightIcon />
                      </ListItemButton>
                    </ListItem>
                  </List>
                </Collapse>
                <Divider variant="middle" />
                <ListItemButton onClick={() => history.push("/Controlpanel")}>
                  <ListItemIcon>
                    <SettingsIcon sx={{ color: "#1C39BB" }} />
                  </ListItemIcon>
                  <ListItemText primary="Control manager" />
                  <ChevronRightIcon />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton onClick={() => history.push("/CheckIn")}>
                  <ListItemIcon>
                    <CloudUploadIcon sx={{ color: "#1C39BB" }} />
                  </ListItemIcon>
                  <ListItemText primary="Check In" />
                  <ChevronRightIcon />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton onClick={() => history.push("/Checkout")}>
                  <ListItemIcon>
                    <CloudDownloadRoundedIcon sx={{ color: "#1C39BB" }} />
                  </ListItemIcon>
                  <ListItemText primary="Check Out" />
                  <ChevronRightIcon />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton onClick={() => history.push("/Playbook")}>
                  <ListItemIcon>
                    <AutoStoriesRoundedIcon sx={{ color: "#1C39BB" }} />
                  </ListItemIcon>
                  <ListItemText primary="Playbook" />
                  <ChevronRightIcon />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton disabled={!islocked} onClick={() => history.push("/chatgptai")}>
                  <ListItemIcon>
                    <SettingsIcon sx={{ color: "#1C39BB" }} />
                  </ListItemIcon>
                  <ListItemText primary="AI Assistant" />
                  <ChevronRightIcon />
                </ListItemButton>
              </List>
            </Card>
            <Snackbar open={popupopen} autoHideDuration={6000} onClose={handlepopupClose}>
              <Alert onClose={handlepopupClose} severity="error" sx={{ width: "100%" }}>
                {errMsgdTable}
              </Alert>
            </Snackbar>
          </Grid>
          <Grid xs={12} item>
            <AppBar position="fixed" sx={{ top: "auto", bottom: 0 }}>
              {/* <Stack direction="row" spacing={2}>
                <Button variant="contained" size="small" sx={{ width: "100%", bgcolor: "#1C39BB" }}>
                  <Typography sx={{ fontSize: 13 }}>Logged user: {usernameinfo}</Typography>
                </Button>
              </Stack> */}
              <Box display="flex" justifyContent="center" alignItems="center" height={32}>
                <Typography sx={{ color: "white", fontSize: 14 }}>Logged user: {usernameinfo}</Typography>
              </Box>
            </AppBar>
          </Grid>
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isprogress}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </Grid>
      )}
    </Box>
  );
};

export default HomePage;
